import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import icon from 'flarum/common/helpers/icon';
export default class ShareModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.titleText = this.attrs.title || '';
    this.url = this.attrs.url || window.location.href;
    this.copied = false;
  }
  className() {
    return 'ShareModal Modal--small';
  }
  title() {
    return [icon('fas fa-share-alt', {
      className: 'icon'
    }), ' ', app.translator.trans('bizkaitarra-aurrera-pwa.forum.share_modal.title') || 'Compartir'];
  }
  content() {
    const encodedUrl = encodeURIComponent(this.url);
    const encodedTitle = encodeURIComponent(this.titleText);
    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`;
    const telegramUrl = `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`;
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`;
    return m("div", {
      className: "Modal-body"
    }, this.titleText ? m("div", {
      className: "ShareModal-subtitle"
    }, this.titleText) : null, m("div", {
      className: "ShareModal-networks"
    }, m("a", {
      className: "Button ShareModal-networkButton ShareModal-networkButton--whatsapp",
      href: whatsappUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, icon('fab fa-whatsapp'), m("span", null, "WhatsApp")), m("a", {
      className: "Button ShareModal-networkButton ShareModal-networkButton--telegram",
      href: telegramUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, icon('fab fa-telegram-plane'), m("span", null, "Telegram")), m("a", {
      className: "Button ShareModal-networkButton ShareModal-networkButton--twitter",
      href: twitterUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, icon('fab fa-twitter'), m("span", null, "X"))), m("div", {
      className: "ShareModal-copySection"
    }, m("label", {
      className: "ShareModal-label"
    }, app.translator.trans('bizkaitarra-aurrera-pwa.forum.share_modal.copy_label') || 'Enlace directo:'), m("div", {
      className: "ShareModal-copyInputGroup"
    }, m("input", {
      type: "text",
      className: "FormControl ShareModal-input",
      value: this.url,
      readonly: true,
      onclick: e => e.target.select()
    }), m(Button, {
      className: `Button ${this.copied ? 'Button--primary ShareModal-copiedButton' : 'Button--default'}`,
      icon: this.copied ? 'fas fa-check' : 'far fa-copy',
      onclick: () => this.copyToClipboard()
    }, this.copied ? app.translator.trans('bizkaitarra-aurrera-pwa.forum.share_modal.copied') || '¡Copiado!' : app.translator.trans('bizkaitarra-aurrera-pwa.forum.share_modal.copy') || 'Copiar'))));
  }
  copyToClipboard() {
    const triggerCopyFallback = () => {
      const input = document.createElement('input');
      input.value = this.url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.onCopySuccess();
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(this.url).then(() => {
        this.onCopySuccess();
      }, () => {
        triggerCopyFallback();
      });
    } else {
      triggerCopyFallback();
    }
  }
  onCopySuccess() {
    this.copied = true;
    m.redraw();
    setTimeout(() => {
      this.copied = false;
      m.redraw();
    }, 2500);
  }
}
flarum.reg.add('bizkaitarra-aurrera-pwa', 'forum/components/ShareModal', ShareModal);